import React from "react";
import { MediaProvider } from "react-media-universal";
import { Global, css } from "@emotion/core";
import sanitize from "sanitize.css";
import { baseStyle } from "theme/config/baseStyle";
import { resetStyle } from "theme/config/reset";
import { fontString } from "theme/assets/fonts";
import Site from "theme/components/Site";

const App = () => {
    return (
        <>
            <Global
                styles={css`
                    ${sanitize}
                    ${fontString}
                    ${resetStyle}
                    ${baseStyle}
                `}
            />
            <MediaProvider>
                <Site />
            </MediaProvider>
        </>
    );
};

export default App;
